import { onAddSun } from './onAddSun.js';

export function onAdd(map) {
  return onAddSun(this, map);
}
